<template>
  <div>
    <b-modal id="modalEditCompanies" ref="modalEditCompanies" :title="$t('Companies')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-tabs pills card>
          <b-tab :title="$t('Company')">
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                  {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_name"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.jur_adress"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.act_adress"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('ITIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.inn"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Reg code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.kpp"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Excutive managers')">
            <b-form-group label-align="right" :label="$t('CEO')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.headman"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Accountant')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.bookeeper"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_headman"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_bookeeper"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Bank')">
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.name" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.city" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('BIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.bic" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Correspondent account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.kschet" disabled/>
            </b-form-group>
            <b-button variant="secondary" size="sm" @click="showBank">{{ $t('Select bank') }}</b-button>
            <b-form-group label-align="right" :label="$t('Personal account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.account"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Contract')">
            <b-form-group label-align="right" :label="$t('Contract number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.contract_number"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.contract_place"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Number format')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.number_format"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Client prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.client_prefix"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Service place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.service_place"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditCompanies.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal id="modalBank" ref="modalBank" :title="$t('Banks')" hide-footer>
      <b-table striped hover small
        :items="banks"
        :fields="banksFields"
        selectable
        @row-selected="onRowSelected"
        select-mode="single">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="selectBank">{{ $t('Save')}}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalBank.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      banksFields: [
        {key: 'bank_id', label: 'ID', sortable: true},
        {key: 'bic', label: this.$i18n.t('BIN'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true}
      ],
      selectedBank: null,
      bank: {
        bic: '',
        city: '',
        name: '',
        kschet: ''
      }
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      this.editItem.supplier_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_COMPANIES', this.editItem)
        : this.$store.dispatch('Settings/CREATE_COMPANIES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_COMPANIES')
          this.$refs.modalEditCompanies.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id !== 0) {
        if (this.editItem.bank_id !== 0) {
          for (let el of this.banks) {
            if (el.bank_id === this.editItem.bank_id) {
              this.bank.bic = el.bic
              this.bank.city = el.city
              this.bank.name = el.name
              this.bank.kschet = el.kschet
            }
          }
        }
        this.$store.dispatch('Settings/GET_CURRENT_SUPPLIER', this.editItem.id)
        this.editItem.contract_number = this.currentSupplier.contract_number
        this.editItem.contract_place = this.currentSupplier.contract_place
        this.editItem.number_format = this.currentSupplier.number_format
        this.editItem.client_prefix = this.currentSupplier.client_prefix
        this.editItem.service_place = this.currentSupplier.service_place
      }
    },
    showBank () {
      this.selectedBank = null
      this.$root.$emit('bv::show::modal', 'modalBank', '#btnShow')
    },
    onRowSelected (selected) {
      this.selectedBank = selected[0]
    },
    selectBank () {
      if (!this.selectedBank) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Bank'), 'Error')
        return
      }
      this.editItem.bank_id = this.selectedBank.bank_id
      this.bank.bic = this.selectedBank.bic
      this.bank.city = this.selectedBank.city
      this.bank.name = this.selectedBank.name
      this.bank.kschet = this.selectedBank.kschet
      this.$refs.modalBank.hide()
    }
  },
  computed: {
    currentSupplier () {
      return this.$store.getters['Settings/CURRENT_SUPPLIER']
    },
    banks () {
      return this.$store.getters['ReferenceBooks/BANKS']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/companies/editModal.vue